import React, {Component} from 'react';
import { BASE_URL } from '../../constants/app_routes';
import {Button, Form, Input, Grid, Header, Icon, Image, Table, Modal, Popup, Segment,Divider, Message,Checkbox} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import Loader from "../universal/loader";
import { uploadTranscription,formatTranscription,uploadPDF} from "../../data/report_api";
import { SSE } from "sse";
import { getHeader } from '../../data/user_api';

const uuidv1 = require('uuid/v1');

class AutoTranscription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showTranscription: false,
            audioFile:undefined,
            transcriptionText:"",
            errorMessage:undefined,
            loading:false,
            compactMode:false,
            fullScreen:false,
            formattedText:``,
            parsedRooms:{rooms:[]},
            parsedRoomsHistory:[],
           parseError:undefined,
           currentStep:1,
           comparisonView:false,
           comparisonList:[],
           selectedModel:"gpt-5.6-luna",
           selectedVoiceModel:"gpt-transcribe",
           joinItemConditionEntries:false,
           additionalAIInstruction:"",
           originalReportAvailable:true,
           roomsVisible:true,
           groupsVisible:true,
           itemsVisible:true,
           handleAsPDF:false,
           originalCompValue:undefined,
           originalParsedRooms:undefined
        }
    }

    streamFormatTranscription = async (model_type) =>  {
        this.setState({loading:true, currentStep: 3,errorMessage:undefined})
        let additionalAIInstruction = this.state.additionalAIInstruction
        if(this.props.other_template) {
            additionalAIInstruction = `Also, on the narration, if it is stated that a group is as per check in, for example, "Floor as per check in", "Walls as per check in", "Ceiling as per check in", you should output this as just G-[group name]. So if on the narration there appears "Walls as per check in", it should be output as "G-Walls", and so on.   ${additionalAIInstruction}`
        }
        let source = new SSE(`${BASE_URL}/stream/streamFormatTranscription`, { payload:JSON.stringify({transcription_text:this.state.transcriptionText,
            reportId:this.props.reportDetails["id"],
            token:this.props.reportDetails["viewer_token"],
            handleAsPDF:this.state.handleAsPDF,
            model_type:model_type,
            additionalAIInstruction:additionalAIInstruction})
            ,headers: getHeader()});

            source.onmessage = (event) => {
                let data = JSON.parse(event.data)
                let newChunk = data.data ? data.data : ""

                this.setState(prev => ({
                    formattedText: (prev.formattedText || "") + newChunk
                }))
}
        
        source.onerror = (err) => {
        //   console.error("EventSource failed:", err);
          source.close()
          this.setState({errorMessage:"There was an error while receiving formatted data",loading:false})
        };
        
        source.addEventListener("end", (event) => {
        //   console.log("Received end event:", event);
          this.setState({loading:false})
           source.close()
        });
        source.stream();
    }

    undoLastAction = () =>{
        let parsedRoomsHistory =  JSON.parse(JSON.stringify(this.state.parsedRoomsHistory));
        let stateToRestore = parsedRoomsHistory.pop()
        this.setState({parsedRooms:stateToRestore,parsedRoomsHistory:parsedRoomsHistory})
    }

    addToParsedRoomsHistory =(currParsedRooms)=>{
        let newCurrParsedRooms =  JSON.parse(JSON.stringify(currParsedRooms));
        let newparsedRoomsHistory = [...this.state.parsedRoomsHistory]
        newparsedRoomsHistory.push(newCurrParsedRooms)
        if(newparsedRoomsHistory.length > 15) {
            newparsedRoomsHistory.shift()
        }
        return newparsedRoomsHistory
    }

    updateHistoryOnBlur = (valueToCompare)=>{
        if (this.state.originalCompValue != valueToCompare){
            this.setState({parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.originalParsedRooms),originalCompValue:undefined,originalParsedRooms:undefined})
        }
    }

    combineCondition = (roomindex,groupindex,itemindex) =>{
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));
        newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name = `${newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name} ${newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_condition}`
        newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_condition = ""
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }
    combineAbove = (roomindex,groupindex,itemindex) => {

        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));
        if (newParsedRooms.rooms[roomindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex] != null){
                if (newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex] != null){

                //    If there is already an item condition, add concatenate with a comma
                    if(newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex-1].item_condition == "")
                    {newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex-1].item_condition += newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name}
                    else
                    {newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex-1].item_condition += `, ${newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name}`}
                    
                    newParsedRooms.rooms[roomindex].groups[groupindex].items.splice(itemindex,1)
                }    
            } 
        }
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }
    moveRight = (roomindex,groupindex) => {
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));
        if (newParsedRooms.rooms[roomindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex] != null){
                let newItems =  [...newParsedRooms.rooms[roomindex].groups[groupindex-1].items,{item_name:newParsedRooms.rooms[roomindex].groups[groupindex].group_name,item_condition:newParsedRooms.rooms[roomindex].groups[groupindex].item_condition||""},...newParsedRooms.rooms[roomindex].groups[groupindex].items]
                newParsedRooms.rooms[roomindex].groups[groupindex-1].items = newItems
                newParsedRooms.rooms[roomindex].groups.splice(groupindex,1)
            } else {
                let newGroups =  [...newParsedRooms.rooms[roomindex-1].groups,{group_name:newParsedRooms.rooms[roomindex].room_name,items:[]},...newParsedRooms.rooms[roomindex].groups]
                newParsedRooms.rooms[roomindex-1].groups = newGroups
                newParsedRooms.rooms.splice(roomindex,1)
            }
        }
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }

    moveLeft = (roomindex,groupindex,itemindex) => {
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));
        if (newParsedRooms.rooms[roomindex] != null && newParsedRooms.rooms[roomindex].groups[groupindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex] != null){
                let oldItemName = newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name
                let oldGroupItems = newParsedRooms.rooms[roomindex].groups[groupindex].items.slice(0,itemindex)
                let newGroupItems = newParsedRooms.rooms[roomindex].groups[groupindex].items.slice(itemindex + 1)
                newParsedRooms.rooms[roomindex].groups[groupindex].items = oldGroupItems
                let newgroup = {group_name: oldItemName,items:[...newGroupItems]}
                newParsedRooms.rooms[roomindex].groups.splice(groupindex+1,0,newgroup)

            } else {
                let oldGroupName = newParsedRooms.rooms[roomindex].groups[groupindex].group_name
                let oldRoomGroups = newParsedRooms.rooms[roomindex].groups.slice(0,groupindex)
                let newRoomGroups = newParsedRooms.rooms[roomindex].groups.slice(groupindex + 1)
                newParsedRooms.rooms[roomindex].groups = oldRoomGroups
                let newRoom = {room_name: oldGroupName,groups:[...newRoomGroups]}
                newParsedRooms.rooms.splice(roomindex+1,0,newRoom)
            }
        }
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }

    handleAdd = (roomindex,groupindex,itemindex) => {
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));

        if (newParsedRooms.rooms[roomindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex] != null){
                if (newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex] != null){
                    newParsedRooms.rooms[roomindex].groups[groupindex].items.splice(itemindex,0,{item_name:newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name,item_condition:newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_condition})
                }
                else 
                {
                    newParsedRooms.rooms[roomindex].groups.splice(groupindex,0,{group_name:newParsedRooms.rooms[roomindex].groups[groupindex].group_name, items:[]})
                }
            } else {
                newParsedRooms.rooms.splice(roomindex,0, {room_name:newParsedRooms.rooms[roomindex].room_name, groups:[]})   
            }
        }
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }

    handleDelete = (roomindex,groupindex,itemindex) => {
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));

        if (newParsedRooms.rooms[roomindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex] != null){
                if (newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex] != null){
                    newParsedRooms.rooms[roomindex].groups[groupindex].items.splice(itemindex,1)
                }
                else 
                {
                    newParsedRooms.rooms[roomindex].groups.splice(groupindex,1)
                }
            } else {
                newParsedRooms.rooms.splice(roomindex,1)   
            }
        }
        this.setState({parsedRooms:newParsedRooms,parsedRoomsHistory:this.addToParsedRoomsHistory(this.state.parsedRooms)})
    }
    handleDataChange = (roomindex,groupindex,itemindex,item_name,item_condition,value) => {
        let newParsedRooms = JSON.parse(JSON.stringify(this.state.parsedRooms));

        if (newParsedRooms.rooms[roomindex] != null){
            if (newParsedRooms.rooms[roomindex].groups[groupindex] != null){

                if(newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex] != null) {
                    if (item_name) {
                        newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_name = value.substring(0, 254)
                    }
                    if (item_condition) {
                        newParsedRooms.rooms[roomindex].groups[groupindex].items[itemindex].item_condition = value.substring(0, 254)
                    }
                    this.setState({parsedRooms:newParsedRooms})
                } else {
                    newParsedRooms.rooms[roomindex].groups[groupindex].group_name = value.substring(0, 254)
                    this.setState({parsedRooms:newParsedRooms})
                }
            } else {
                newParsedRooms.rooms[roomindex].room_name = value.substring(0, 254)
                this.setState({parsedRooms:newParsedRooms})
            }
        }        
    }
     

    downloadNarration = async () =>{
    var blob = new Blob([this.state.transcriptionText.replace(/\./g, '.\n')], {type: "text/plain;charset=utf-8"});
    var a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `Narration for ${this.props.reportDetails["address"]}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    }
    uploadTranscription = async () => {
        this.setState({loading:true, errorMessage:undefined})
        let formData = new FormData()
        formData.append("file", this.state.audioFile)
        formData.append("model",this.state.selectedVoiceModel)
        // formData.append("report_id", this.props.reportDetails["id"])
        let response = await uploadTranscription(formData)
        if (response.success) {
            this.setState({transcriptionText:response.transcriptionText, currentStep:2,handleAsPDF:false})
        } else {
            this.setState({errorMessage:response.statusMessage})
        }
        this.setState({loading:false})
    }

        uploadPDF = async () => {
        this.setState({loading:true, errorMessage:undefined})
        let formData = new FormData()
        formData.append("file", this.state.pdfFile)
        // formData.append("report_id", this.props.reportDetails["id"])
        let response = await uploadPDF(formData)
        if (response.success) {
            this.setState({transcriptionText:response.transcriptionText.replace(/\s+/g, ' ') .replace(/^\s+|\s+$/g, ''), currentStep:2,handleAsPDF:true})
        } else {
            this.setState({errorMessage:response.statusMessage})
        }
        this.setState({loading:false})
    }

    formatTranscription = async () => {
        this.setState({loading:true, currentStep: 3})
        let formData = new FormData()
        formData.append("transcription_text", this.state.transcriptionText)
        formData.append("report_id", this.props.reportDetails["id"])
        formData.append("model_type",this.state.selectedModel)
        formData.append("additionalAIInstruction",this.state.additionalAIInstruction)
        formData.append("handleAsPDF", this.state.handleAsPDF)
        let response = await formatTranscription(formData)
        if (response.success) {
            this.setState({formattedText:response.formattedText})
        } else {
            this.setState({errorMessage:response.statusMessage})
        }
        this.setState({loading:false})
    }  

    parseFormattedResponse = async () => {

        let str = this.state.formattedText
        let segments = str.trim().split("\n") //split by newline
        let unusables = []
        let parsedObject = {rooms:[]}
        let currRoom = undefined
        let currGroup = undefined
        let currItem = undefined
        for(let i = 0; i < segments.length; i++) {
            if (segments[i].length > 254) {
                if (!segments[i].includes("IC-"))
                segments[i] = segments[i].substring(0, 254);
            }
            
            if (segments[i].includes("R-")){
                let newRoom = {room_name:segments[i].replace("R-",""), groups:[]}
                parsedObject.rooms.push(newRoom)
                currRoom = parsedObject.rooms.indexOf(newRoom)
                currItem = undefined
                currGroup = undefined

            }
            else if (segments[i].includes("G-")){
                if (currRoom == undefined) {
                    let newRoom = {room_name:"NO ROOM DATA", groups:[]}
                    parsedObject.rooms.push(newRoom)
                    currRoom = parsedObject.rooms.indexOf(newRoom)
                }
                let newGroup = {group_name:segments[i].replace("G-",""), items:[]}
                parsedObject.rooms[currRoom].groups.push(newGroup)
                currGroup = parsedObject.rooms[currRoom].groups.indexOf(newGroup)
                currItem = undefined
                // if (this.props.other_template) {
                //     let newItem = {}
                //     if(this.state.originalReportAvailable){
                //      newItem = {item_name:"As per check in with the exception of:",  item_condition:""}
                //     } else {
                //         newItem = {item_name:"In good condition and clean with the exception of:",  item_condition:""}
                //     }
                //     parsedObject.rooms[currRoom].groups[currGroup].items.push(newItem)
                // }
            }
            else if (segments[i].includes("IN-")){
                if (currRoom == undefined) {
                    let newRoom = {room_name:"NO ROOM DATA", groups:[]}
                    parsedObject.rooms.push(newRoom)
                    currRoom = parsedObject.rooms.indexOf(newRoom)
                    currGroup = undefined
                    currItem = undefined
                }
                if (currGroup == undefined) {
                    let newGroup = {group_name:"NO GROUP DATA", items:[]}
                    parsedObject.rooms[currRoom].groups.push(newGroup)
                    currGroup = parsedObject.rooms[currRoom].groups.indexOf(newGroup)
                    currItem = undefined
                }
                
                let newItem = {item_name:segments[i].replace("IN-",""), item_condition:""}
                    parsedObject.rooms[currRoom].groups[currGroup].items.push(newItem)
                    currItem = parsedObject.rooms[currRoom].groups[currGroup].items.indexOf(newItem)
                }
            else if (segments[i].includes("IC-")){

                if (currRoom == undefined) {
                    let newRoom = {room_name:"NO ROOM DATA", groups:[]}
                    parsedObject.rooms.push(newRoom)
                    currRoom = parsedObject.rooms.indexOf(newRoom)
                    currGroup = undefined
                    currItem = undefined
                }
                if (currGroup == undefined) {
                    let newGroup = {group_name:"NO GROUP DATA", items:[]}
                    parsedObject.rooms[currRoom].groups.push(newGroup)
                    currGroup = parsedObject.rooms[currRoom].groups.indexOf(newGroup)
                    currItem = undefined
                }

                let itemCondition = segments[i].replace("IC-","")
                if (currItem != undefined) {
                    if(!this.state.joinItemConditionEntries){
                        parsedObject.rooms[currRoom].groups[currGroup].items[currItem].item_condition = itemCondition
                        currItem = undefined  
                    } else {
                        if (parsedObject.rooms[currRoom].groups[currGroup].items[currItem].item_condition == "") { 
                            parsedObject.rooms[currRoom].groups[currGroup].items[currItem].item_condition = itemCondition
                        } 
                        else{
                            parsedObject.rooms[currRoom].groups[currGroup].items[currItem].item_condition = `${parsedObject.rooms[currRoom].groups[currGroup].items[currItem].item_condition}, ${itemCondition}`}
                    }
                } else {
                    if (itemCondition.length > 254) {
                        itemCondition = itemCondition.substring(0, 254);
                    }
                    let newItem = {item_name:itemCondition, item_condition:""}
                    parsedObject.rooms[currRoom].groups[currGroup].items.push(newItem)
                }
            }
            else {unusables.push(segments[i])}
        }

        this.setState({parsedRooms:parsedObject,currentStep:4})

     }

     parseTranscription = async () => {

        let str = this.state.transcriptionText
        str = str.trim()

        let splitItems = str.split(".").join(",").split(",")
        let itemsArr = []
        for (let i = 0; i < splitItems.length; i++) {
            let word = splitItems[i].trim()
            word = word.charAt(0).toUpperCase()+ word.slice(1)
            itemsArr.push({item_name: word?word:"blank", item_condition:""})
        }
        let parsedObject={rooms:[{room_name:itemsArr[0].item_name,groups:[{group_name:itemsArr[1].item_name,items:itemsArr.slice(2)}]}]}
        try {
            this.setState({parsedRooms:parsedObject, currentStep:4})
        } catch (error) {
            this.setState({parseError:error})
        }
     }

     parseTranscriptionForComparison = async () => {

        let str = this.state.transcriptionText
        str = str.trim()

        let splitItems = str.split(".").join(",").split(",")
        let itemsArr = []
        for (let i = 0; i < splitItems.length; i++) {
            let word = splitItems[i].trim()
            word = word.charAt(0).toUpperCase()+ word.slice(1)
            itemsArr.push(word)
        }
            this.setState({comparisonList:itemsArr})
     }


    render() {
        window.onbeforeunload = function() { return "Do you want to close this tab?"; }
        let modelOptions = [
            {key: 5, text: "GPT 5.6 Luna - Default", value: "gpt-5.6-luna"},
            {key: 6, text: "GPT 5.6 Terra", value: "gpt-5.6-terra"},
            {key: 7, text: "GPT 5.6 Sol", value: "gpt-5.6-sol"},
            {key: 1, text: "GPT 4.1", value: "gpt-4.1"},
            {key: 2, text: "GPT4-O", value: "gpt-4o"},
            {key: 4, text: "GPT4", value: "gpt-4"},
            {key: 3, text: "GPT3.5", value: "gpt-3.5-turbo"},
        ] 
        let voiceModelOptions = [
    {key: 4, text: "GPT Transcribe - Default", value: "gpt-transcribe"},
    {key: 1, text: "Whisper", value: "whisper-1"},
    {key: 2, text: "GPT4o Mini Transcribe (Faster)", value: "gpt-4o-mini-transcribe"},
    {key: 3, text: "GPT4o Transcribe (Slower, More Powerful)", value: "gpt-4o-transcribe"},
];
        const comparisonStyle = {height:"600px", overflow:"scroll"}
        return (<Segment>
            <Modal size={this.state.fullScreen ? "fullscreen" : this.state.comparisonView ?"fullscreen" : "large"} open={this.props.showTranscription} onClose={(e) => {
            }}><Modal.Header>Audio Transcription and Importing</Modal.Header>
            <Modal.Content style={{paddingTop: '0'}}>
                <div className="modal-close-button">
                    <Button basic icon negative onClick={(e) => {
                        this.props.handleClose();
                    }}><Icon name="close"/></Button>
                </div>
                    <Modal.Description>
                        {this.state.currentStep != 4 && <Message warning>Make sure to watch or read one of the guides before using - <a target="_blank" href="https://youtu.be/z767DymmWNI">VIDEO GUIDE</a><br/> Download the Quick AI Explanation Guide (with Pictures) here - <a href="https://www.hinchpm.com/wp-content/uploads/2026/04/AI-Guide-UPDATED-26.docx">WRITTEN GUIDE</a><br/>Remember it is still your responsibility to verify accuracy!
                        </Message>}
                        {this.state.errorMessage && <Message>{this.state.errorMessage}</Message>}
                        <div style={{textAlign:"center"}}>  <Button.Group>
    <Button labelPosition='left' onClick={()=>{this.setState({currentStep:this.state.currentStep - 1,errorMessage:undefined})}}disabled={this.state.currentStep == 1}icon='left chevron' content='Prev. Step' />
    <Button labelPosition='right' onClick={()=>{this.setState({currentStep:this.state.currentStep + 1, errorMessage:undefined})}} disabled={this.state.currentStep == 4}icon='right chevron' content='Next Step' />
  </Button.Group></div>
{this.state.currentStep == 1  && <Segment><Header as="h2"> Step 1 - Convert Audio / PDF to Text</Header>
   <Segment> <Form>
    <Header>Transcribe Audio File</Header>
            <Form.Field inline>
              <Form.Dropdown inline selection
              label={<span>Ai Model Selection   <Popup trigger={<Icon circular name="question"></Icon>}><span>The default model is the recommended one for a first try. If the returned result is incorrect or missing areas of the transcription, please try other model types, it is recommended to go down the list in the order presented as this is the order of model effectiveness.</span></Popup> </span>}
              placeholder="Whisper-1"
              options={voiceModelOptions}
              defaultValue={this.state.selectedVoiceModel}
              onChange={(e,option) => {
                  this.setState({selectedVoiceModel:option.value })
                        }}/>
                      
                        </Form.Field>
                        <Divider/>
                            <Form.Group>
            <Form.Field inline >
                <label>Audio File</label>
                <Input
                    type="file"
                    required
                    accept="audio/*"
                    ref="addAudio"
                    onChange={(e) => {
                        if (e.target.files[0].size > 26214400){
                            this.setState({errorMessage:'ERROR: File size over 26 MB, please compress audio or split it into multiple parts. You can google "compress/split audio file" for several sites that can help with this'})
                        } else {
                            
                            this.setState({audioFile:e.target.files[0], errorMessage:undefined})
                        }
                    }}
                />
            </Form.Field>
            <Form.Field>
            <Button primary onClick={()=>{this.uploadTranscription()}} loading={this.state.loading} disabled={!this.state.audioFile ||this.state.loading || this.state.transcriptionText}>Transcribe Audio File</Button>
            </Form.Field>
        </Form.Group>
            </Form>
<Message>If an "Invalid File Type" error occurs, please convert your audio file to MP3 using - <a target="_blank" rel="noopener noreferrer"href="https://cloudconvert.com/m4a-to-mp3">This tool</a></Message> </Segment>

               <Segment>     <Header>Transcribe PDF File</Header><Form>
                            <Form.Group>
            <Form.Field inline >
                <label>PDF File</label>
                <Input
                    type="file"
                    required
                    accept="application/pdf"
                    ref="addPDF"
                    onChange={(e) => {
                        if (e.target.files[0].size > 50214400){
                            this.setState({errorMessage:'ERROR: File size over 50 MB, please compress PDF. You can google "compress PDF" for several sites that can help with this, such as ilovepdf.com or smallpdf.com'})
                        } else {
                            
                            this.setState({pdfFile:e.target.files[0], errorMessage:undefined})
                        }
                    }}
                />
            </Form.Field>
            <Form.Field>
            <Button primary onClick={()=>{this.uploadPDF()}} loading={this.state.loading} disabled={!this.state.pdfFile || this.state.loading || this.state.transcriptionText}>Transcribe PDF</Button>
            </Form.Field>
        </Form.Group>
            </Form>
            <Message>Transcribing from a PDF is intended for use with "Other" check outs to get a different company's report onto the Hinch report structure, bear in mind there may be errors. Technically it can also be used to load a PDF from a check in report onto another check in. If you choose to add rooms from the original report this way you will not be able to use the AI audio transcription at the same time. Remember it is always the clerk's responsibility to check for accuracy <p/><strong>Note that PDFs of scanned documents will not work, only PDFs with selectable text will work. And results may vary wildly depending on how the source PDF is formatted. IF your PDF file is a scanned document you need to run it through an OCR program so the text becomes selectable, you can use this one:<a target="_blank" rel="noopener noreferrer" href=" https://www.ilovepdf.com/ocr-pdf">https://www.ilovepdf.com/ocr-pdf</a> or google OCR PDF.</strong>
            </Message>
            </Segment>
        </Segment>}
        {this.state.currentStep == 2 && <Segment>
            <Header as="h2"> Step 2 - Format Transcription</Header>
                <Button loading={this.state.loading} disabled={this.state.loading} onClick={()=>{this.parseTranscription()}}>Parse Transcription As Is</Button>
            <Button loading={this.state.loading} onClick={()=>{this.downloadNarration()}}>Download Narration For Sending to Typist</Button>
            <hr/>
            <strong>Additional AI Instructions</strong><Popup trigger={<Icon circular name="question"></Icon>}><span>You may specify additional instructions for the AI in case some part of the formatting is not being correctly performed (If a section of a room is missing for example, you can specify it to make sure that section does not get left out, and so on.) </span></Popup>
            <Form.Input fluid value={this.state.additionalAIInstruction} onChange={(e) => {this.setState({additionalAIInstruction:e.target.value})}} />
            <hr/>
            <Form><Form.Group inline>
            <Button primary loading={this.state.loading} disabled={this.state.loading} 
            onClick={
                // ()=>{this.streamFormatTranscription(this.state.selectedModel)}

                ()=>{                this.formatTranscription()}
                }>Format Using AI</Button>
              <span>AI Model Selection:</span><Form.Dropdown inline selection
                        placeholder="GPT4O"
                        options={modelOptions}
                        defaultValue={this.state.selectedModel}
                        onChange={(e,option) => {
                            this.setState({selectedModel:option.value })
                        }}/>
                        <Popup trigger={<Icon circular name="question"></Icon>}><span>The default model is the recommended one for a first try. If the returned result is incorrect or missing areas of the transcription, please try other model types, it is recommended to go down the list in the order presented as this is the order of model effectiveness.</span></Popup>
            </Form.Group>
            {this.state.transcriptionText.length > 25000 && <Message ><Message.Header>Character Count is High</Message.Header><p>
            The character limit is high. When attempting a format using AI with a count above this amount, there is a chance you will not get the full result back. It could also still work just fine. </p>
            <p> If it does not return the full transcription, please split the transcription text over this amount and save it in a text document, then format the parts using AI separately. To format the other parts after this current first try, open the transcription window, click "Next Step" to go directly to Step 2, and paste the split part into the text box, repeat for as many times as there are parts over the character amount. Be sure to split the text by room to ensure good accuracy.</p></Message>}
            {this.state.transcriptionText.length == 0 && this.state.handleAsPDF && <Message><Message.Header>PDF NOT WORKING? READ THIS</Message.Header>Looks like you tried to transcribe a PDF but nothing is being returned. This is likely because the PDF is a scan of a document, and not an actual document with text that you can select / copy  / paste. To get around this you must use an OCR service to make the text in the document selectable. You can use this one <a target="_blank" rel="noopener noreferrer" href=" https://www.ilovepdf.com/ocr-pdf">https://www.ilovepdf.com/ocr-pdf</a> or google OCR PDF. Then go back to step 1 with the new file and try again. </Message>}
            <p><strong>Character Count:</strong>{this.state.transcriptionText.length}</p>
                <Form.TextArea
                    rows={20}
                    label="Transcribed Text"
                    name="transcribed_text"
                    value={this.state.transcriptionText}
                    onChange={(e)=>{this.setState({transcriptionText:e.target.value})}}
                    />
            </Form>
            </Segment>}

        {this.state.currentStep == 3 && <Segment>
            <Header as="h2"> Step 3 - Parse The AI Formatted Result</Header>
        {!this.state.loading && <React.Fragment><Checkbox defaultChecked={this.state.joinItemConditionEntries} onChange={(e, data) => {this.setState({joinItemConditionEntries:data.checked})}} /><strong>Join together successive IC entries</strong>
        <Popup trigger={<Icon circular name="question"></Icon>}><span>If enabled, will automatically join several item condition entries which may have been separated into their own separate entries by the AI (When an IC- appears in the formatted text more than once in a row) </span></Popup>
        <br></br>
        {/* {this.props.other_template && <div><Checkbox defaultChecked={this.state.originalReportAvailable} onChange={(e, data) => {this.setState({originalReportAvailable:data.checked})}} /><strong>Original Report Available</strong>
        <Popup trigger={<Icon circular name="question"></Icon>}><span>If enabled, every group will have an automatic "As per Check In With Exception Of:", if disabled, every group will have an automatic "In Good Condition and Clean With Exception Of:" </span></Popup>
        </div>} */}
        </React.Fragment>
        }
        
        <hr/>
        <Button primary loading={this.state.loading} disabled={this.state.loading} onClick={()=>{this.parseFormattedResponse()}}>Parse Formatted Text</Button> <Message warning>PLEASE NOTE: Response Streaming currently disabled, no continuous preview text will be shown, please wait until AI finishes, and then text will be displayed below</Message>
        {this.state.parseError && <Message>{this.state.parseError}</Message>}
        <Form>
        <Form.TextArea
        rows={20}
            label="Formatted Text"
            name="formatted_text"
            value={this.state.formattedText}
            onChange={(e)=>{this.setState({formattedText:e.target.value})}}
        />
            </Form>
            </Segment>}

        {this.state.currentStep == 4  &&  <Segment>
                <Header as="h2"> Step 4 - Verify and Correct Mistakes</Header>
            <Button primary compact loading={this.state.loading} disabled={this.state.loading} onClick={()=>{this.props.loadAIData(this.state.parsedRooms,this.state.handleAsPDF? false: this.props.other_template);this.props.handleClose()}}>Load Into Report</Button>
            <Button compact onClick={()=>{this.setState({comparisonView: !this.state.comparisonView}); this.parseTranscriptionForComparison()}}>Open Comparison View</Button>
            <Button compact onClick={()=>{this.setState({compactMode: !this.state.compactMode}); }}>Toggle Compact Mode</Button>
            <Button compact onClick={()=>{this.setState({fullScreen: !this.state.fullScreen}); }}>Toggle Fullscreen</Button>
            <hr/>
            <Button compact onClick={()=>{this.setState({roomsVisible: !this.state.roomsVisible}); }}>{this.state.roomsVisible? "Hide" :"Unhide"} Rooms</Button>
            <Button compact onClick={()=>{this.setState({groupsVisible: !this.state.groupsVisible}); }}>{this.state.groupsVisible? "Hide" :"Unhide"} Groups</Button>
            <Button compact onClick={()=>{this.setState({itemsVisible: !this.state.itemsVisible}); }}>{this.state.itemsVisible? "Hide" :"Unhide"} Items</Button>
            <Button circular icon negative style={{zIndex:"999",position:"sticky",top:"5px",float:"right"}} disabled={this.state.parsedRoomsHistory.length < 1}compact onClick={()=>{this.undoLastAction()}}> <Icon name="undo"/> Undo ({this.state.parsedRoomsHistory.length})</Button>
                <Grid columns={this.state.comparisonView?2:1}><Grid.Column><Segment style={this.state.comparisonView?comparisonStyle:null}secondary>{this.state.parsedRooms.rooms.map((room, roomindex)=>{
                    return <React.Fragment key={`room_${roomindex}`} >
                        {!this.state.compactMode && <React.Fragment><div style={{display:this.state.roomsVisible?"":"none"}}><Segment secondary attached='top' color="green">
                        <Header floated="left">Room </Header><div style={{textAlign:"right"}}>
                        <Button compact color="blue" basic disabled icon size="mini"><Icon name="left arrow"></Icon></Button>
                        <Button compact color="blue" basic disabled={roomindex == 0} onClick={()=>{this.moveRight(roomindex,undefined)}} icon size="mini"><Icon name="right arrow"></Icon></Button>
                        <Button compact basic color="green" icon size="mini" onClick={()=>{this.handleAdd(roomindex,undefined,undefined)}}><Icon name="plus"></Icon></Button>
                        <Popup trigger={<Button compact color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>}content={<div><p>Are you sure?</p><Button negative content='Delete'onClick={()=>{this.handleDelete(roomindex,undefined,undefined)}}/>
                            </div>}
                    on='click'
                    position='right center'
                    hideOnScroll/></div>
                </Segment>
                <Segment attached='bottom' >
                <Form>
                    <Form.Input  label='Room Name' value={room.room_name}
                    onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                    onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                    onChange={(e)=>{this.handleDataChange(roomindex,undefined,undefined,undefined,undefined, e.target.value)}} />
                </Form>
                </Segment></div></React.Fragment>}
                {/* COMPACTMODE ROOMS */}
                {this.state.compactMode && <div style={{display:this.state.roomsVisible?"":"none"}}><Segment className="compact-mode" secondary style={{padding:"1px",display:this.state.roomsVisible}} color="green">
                <Table compact='very' basic='very'>
                <Table.Body><Table.Row><Table.Cell>
                    <Form>
                    <Form.Input fluid value={room.room_name}
                     onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                    onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                    onChange={(e)=>{this.handleDataChange(roomindex,undefined,undefined,undefined,undefined, e.target.value)}} />
    
                </Form></Table.Cell>
                <Table.Cell collapsing style={{textAlign:"right"}}>
                        <Button  color="blue" basic disabled icon size="mini"><Icon name="left arrow"></Icon></Button>
                        <Button  color="blue" basic disabled={roomindex == 0} onClick={()=>{this.moveRight(roomindex,undefined)}} icon size="mini"><Icon name="right arrow"></Icon></Button>
                        <Button  basic color="green" icon size="mini" onClick={()=>{this.handleAdd(roomindex,undefined,undefined)}}><Icon name="plus"></Icon></Button>
                        <Popup trigger={<Button  color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>}content={<div><p>Are you sure?</p><Button negative content='Delete'onClick={()=>{this.handleDelete(roomindex,undefined,undefined)}}/>
                            </div>}
                    on='click'
                    position='right center'
                    hideOnScroll/></Table.Cell></Table.Row></Table.Body></Table>
               
                </Segment></div>}
                {/* COMPACTMODE ROOMS END */}
                    {room.groups.map((group,groupindex)=>{
                        return <div style={{marginBottom:"15px"}} key={`group_${groupindex}`} >{!this.state.compactMode && <React.Fragment>
                            <div style={{display:this.state.groupsVisible?"":"none"}}>
                            <Segment secondary attached='top' style={{width:"97%",marginLeft:"auto"}}color="orange">
                            <Header floated="left">Group </Header><div style={{textAlign:"right"}}>
                                { (group.items.length > 0 || groupindex == 0) &&  <Popup wide="very" trigger={<Button size="mini" basic compact circular icon='question' />}    
                                content={  <Message>
                                    <Message.Header>Arrow disabled</Message.Header>
                                    <Message.List>
                                    {group.items.length > 0 && <Message.Item>Add a group directly below to enable left arrow. (Can't turn group into room if it contains items)</Message.Item>}
                                    {groupindex==0 && <Message.Item>Add a group directly above to enable right arrow. (Can't turn group into item if it is the first group of the room)</Message.Item>}
                                    </Message.List>
                                  </Message>}
                                />}
                        <Button compact color="blue" basic disabled={group.items.length > 0} onClick={()=>{this.moveLeft(roomindex,groupindex)}} icon size="mini"><Icon name="left arrow"></Icon></Button>
                        <Button compact color="blue" disabled={groupindex==0}onClick={()=>{this.moveRight(roomindex,groupindex)}} basic icon size="mini"><Icon name="right arrow"></Icon></Button>
                        <Button compact basic color="green" icon size="mini" onClick={()=>{this.handleAdd(roomindex,groupindex,undefined)}}><Icon name="plus"></Icon></Button>
                        <Popup 
                    trigger={<Button compact color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>}
                    content={<div><p>Are you sure?</p>
                             <Button negative content='Delete' onClick={()=>{this.handleDelete(roomindex,groupindex,undefined)}}/></div>}on='click' position='right center'hideOnScroll/></div> 
                            </Segment>
                            <Segment  attached='bottom'  style={{width:"97%",marginLeft:"auto"}}>
                            <Form>
                                <Form.Input  label='Group Name' value={group.group_name}
                                onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                onChange={(e)=>{this.handleDataChange(roomindex,groupindex,undefined,undefined,undefined, e.target.value)}} />
                            </Form>
                            </Segment>
                            </div></React.Fragment>}
                            {/* COMPACTMODE GROUPS */}
                            {this.state.compactMode && <div style={{display:this.state.groupsVisible?"":"none"}}><Segment className="compact-mode" secondary style={{width:"99%",marginLeft:"auto",padding:"1px"}} color="orange">
                            <Table compact='very' basic='very'>
                                <Table.Body><Table.Row><Table.Cell><Form>
                                    <Form.Input fluid value={group.group_name}
                                    onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                    onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                    onChange={(e)=>{this.handleDataChange(roomindex,groupindex,undefined,undefined,undefined, e.target.value)}} />
                                    </Form></Table.Cell><Table.Cell collapsing>
                                        { (group.items.length > 0 || groupindex == 0) &&  <Popup wide="very" trigger={<Button size="mini" basic compact circular icon='question' />} content={  <Message><Message.Header>Arrow disabled</Message.Header><Message.List>{group.items.length > 0 && <Message.Item>Add a group directly below to enable left arrow. (Can't turn group into room if it contains items)</Message.Item>}{groupindex==0 && <Message.Item>Add a group directly above to enable right arrow. (Can't turn group into item if it is the first group of the room)</Message.Item>}</Message.List></Message>}/>}
                                        <Button compact color="blue" basic disabled={group.items.length > 0} onClick={()=>{this.moveLeft(roomindex,groupindex)}} icon size="mini"><Icon name="left arrow"></Icon></Button>
                                        <Button compact color="blue" disabled={groupindex==0}onClick={()=>{this.moveRight(roomindex,groupindex)}} basic icon size="mini"><Icon name="right arrow"></Icon></Button>
                                        <Button compact basic color="green" icon size="mini" onClick={()=>{this.handleAdd(roomindex,groupindex,undefined)}}><Icon name="plus"></Icon></Button>
                                        <Popup trigger={<Button compact color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>} content={<div><p>Are you sure?</p>
                                        <Button negative content='Delete' onClick={()=>{this.handleDelete(roomindex,groupindex,undefined)}}/></div>}on='click' position='right center'hideOnScroll/>
                                        </Table.Cell></Table.Row></Table.Body></Table>
                                        </Segment></div>}     
                                        {/* COMPACTMODE GROUPS END */}
                
                        {group.items.map((item,itemindex)=>{
                            return <div style={{marginBottom:"15px",display:this.state.itemsVisible?"":"none"}} key={`item_${itemindex}`}>
                                {!this.state.compactMode && <React.Fragment>
                                        <Segment secondary = {itemindex % 2 != 0} tertiary={itemindex % 2 == 0} attached='top' style={{width:"95%",marginLeft:"auto"}}color="blue">
                                            <Header floated="left">Item </Header><div style={{textAlign:"right"}}>
                                                <Popup trigger={<Button compact color="orange" disabled={!item.item_condition}basic icon size="mini" onClick={()=>{this.combineCondition(roomindex,groupindex,itemindex)}}><Icon name="angle double left"></Icon></Button>}>Move Item Condition Text into Item Name</Popup>
                                                <Button compact color="orange" disabled={itemindex==0}basic icon size="mini" onClick={()=>{this.combineAbove(roomindex,groupindex,itemindex)}}><Icon name="up arrow"></Icon></Button>
                                                <Button compact color="blue" basic icon size="mini" onClick={()=>{this.moveLeft(roomindex,groupindex,itemindex)}}><Icon name="left arrow"></Icon></Button>
                                                <Button compact color="blue" disabled basic icon size="mini"><Icon name="right arrow"></Icon></Button>
                                                <Button compact basic color="green" icon size="mini"  onClick={()=>{this.handleAdd(roomindex,groupindex,itemindex)}}><Icon name="plus"></Icon></Button>
                                                <Popup 
                                            trigger={<Button compact color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>}
                                            content={<div>
                                                    <p>Are you sure?</p>
                                                    <Button negative content='Delete'
                                                                onClick={()=>{this.handleDelete(roomindex,groupindex,itemindex)}}/>
                                                    </div>}
                                            on='click'
                                            position='right center'
                                            hideOnScroll/></div>
                                        </Segment>
                                        <Segment attached='bottom' style={{width:"95%",marginLeft:"auto"}}>
                                        <Form>
                                            <Form.Group widths='equal' style={{margin:"0px"}}>
                                                <Form.Input fluid label='Item Name' value={item.item_name} 
                                                onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                                onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                                onChange={(e)=>{this.handleDataChange(roomindex,groupindex,itemindex,1,undefined, e.target.value)}} />
                                                <Form.Input fluid label='Item Condition' value={item.item_condition} 
                                                onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                                onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                                onChange={(e)=>{this.handleDataChange(roomindex,groupindex,itemindex,undefined,1, e.target.value)}} />
                                            </Form.Group>
                                        </Form>
                                        </Segment>
                                        </React.Fragment>}
                                        {/* COMPACTMODE ITEMS */}
                                        {this.state.compactMode && <Segment className="compact-mode" secondary style={{width:"98%",marginLeft:"auto",padding:"1px"}} color="blue">
                                        <Table compact='very' basic='very'>
                                            <Table.Body><Table.Row><Table.Cell><Form>
                                            <Form>
                                            <Form.Group widths='equal' style={{margin:"0px"}}>
                                                <Form.Input fluid  value={item.item_name} 
                                                onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                                 onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                                onChange={(e)=>{this.handleDataChange(roomindex,groupindex,itemindex,1,undefined, e.target.value)}} />
                                                <Form.Input fluid  value={item.item_condition} 
                                                onFocus={(e=>{this.setState({originalCompValue:e.target.value,originalParsedRooms:JSON.parse(JSON.stringify(this.state.parsedRooms))})})}
                                                onBlur={((e)=>this.updateHistoryOnBlur(e.target.value))}
                                                onChange={(e)=>{this.handleDataChange(roomindex,groupindex,itemindex,undefined,1, e.target.value)}} />
                                            </Form.Group>
                                        </Form>                                                </Form></Table.Cell>
                                        <Table.Cell collapsing>
                                        <Popup trigger={<Button compact color="orange" disabled={!item.item_condition}basic icon size="mini" onClick={()=>{this.combineCondition(roomindex,groupindex,itemindex)}}><Icon name="angle double left"></Icon></Button>}>Move Item Condition Text into Item Name</Popup>
                                        <Button compact color="orange" disabled={itemindex==0}basic icon size="mini" onClick={()=>{this.combineAbove(roomindex,groupindex,itemindex)}}><Icon name="up arrow"></Icon></Button>
                                                <Button compact color="blue" basic icon size="mini" onClick={()=>{this.moveLeft(roomindex,groupindex,itemindex)}}><Icon name="left arrow"></Icon></Button>
                                                <Button compact color="blue" disabled basic icon size="mini"><Icon name="right arrow"></Icon></Button>
                                                <Button compact basic color="green" icon size="mini"  onClick={()=>{this.handleAdd(roomindex,groupindex,itemindex)}}><Icon name="plus"></Icon></Button>
                                                <Popup 
                                            trigger={<Button compact color="red" basic icon size="mini"><Icon name="delete"></Icon></Button>}
                                            content={<div>
                                                    <p>Are you sure?</p>
                                                    <Button negative content='Delete'
                                                                onClick={()=>{this.handleDelete(roomindex,groupindex,itemindex)}}/>
                                                    </div>}
                                            on='click'
                                            position='right center'
                                            hideOnScroll/>
                                                    </Table.Cell></Table.Row></Table.Body></Table>
                                                    </Segment>}     
                                                    {/* COMPACTMODE ITEMS END */}
                                                    </div>})}
                                            </div>                    
                    })}
                    </React.Fragment>
                 })} </Segment> 
                 </Grid.Column>
                 {this.state.comparisonView && <Grid.Column><Segment style={comparisonStyle}>{this.state.comparisonList.map((word, index) =>{return <Message warning={index%2 == 0}>{word}</Message>})}</Segment></Grid.Column>}</Grid>
                </Segment>}
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }

}

export default ReportContainer(AutoTranscription);


// WEBPACK FOOTER //
// ./src/views/report/auto_transcription.js